import { createContext, useContext } from "react";
import useNotificationsCable from "../hooks/useNotificationsCable";

const NotificationsContext = createContext([]);

export default function NotificationsProvider({ userId, token, children }) {
  const notifications = useNotificationsCable(userId, token);

  return (
    <NotificationsContext.Provider value={notifications}>
      {children}
    </NotificationsContext.Provider>
  );
}

export function useNotifications() {
  return useContext(NotificationsContext);
}
